var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('TableComponent',{attrs:{"title":'Transactions',"data":_vm.transactions,"heading":_vm.heading,"buttonTitle":'See all transactions',"view":'page',"loading":_vm.loading,"type":'transaction'},on:{"handleClick":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }